import { useEffect, useState } from "react";
import { getUserData, authenticatedFetch } from "@/lib/auth";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

const ClientDashboardSimple = () => {
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const user = getUserData();

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchDashboardData();
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  const fetchDashboardData = async () => {
    try {
      setIsLoading(true);
      
      const currentUser = getUserData();
      console.log('[Dashboard] User data:', currentUser);
      
      if (!currentUser) {
        throw new Error("Usuário não autenticado");
      }
      
      const endpoint = currentUser.user_type === 'internal'
        ? "/api/dashboard/admin.php" 
        : "/api/dashboard/cliente.php";
      
      console.log('[Dashboard] Calling endpoint:', endpoint);
      const response = await authenticatedFetch(endpoint);
      console.log('[Dashboard] Response status:', response.status);

      if (!response.ok) {
        throw new Error("Erro ao carregar dados do dashboard");
      }

      const result = await response.json();
      setDashboardData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Erro desconhecido");
    } finally {
      setIsLoading(false);
    }
  };

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-destructive">
              <AlertCircle className="h-5 w-5" />
              Erro ao carregar dashboard
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">{error}</p>
            <Button onClick={fetchDashboardData} className="w-full">
              Tentar novamente
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground mt-2">
          Bem-vindo, {user?.full_name}!
        </p>
      </div>

      {isLoading ? (
        <Card>
          <CardContent className="p-6">
            <p>Carregando...</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4 md:grid-cols-3">
          <Card>
            <CardHeader>
              <CardTitle className="text-sm font-medium">Tickets Abertos</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">
                {(dashboardData?.data?.tickets?.by_status?.open ?? 
                  dashboardData?.tickets?.by_status?.open ?? 
                  0)}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-sm font-medium">Em Andamento</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">
                {(dashboardData?.data?.tickets?.by_status?.in_progress ?? 
                  dashboardData?.tickets?.by_status?.in_progress ?? 
                  0)}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-sm font-medium">Fechados</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">
                {(dashboardData?.data?.tickets?.by_status?.closed ?? 
                  dashboardData?.tickets?.by_status?.closed ?? 
                  0)}
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      <Card>
        <CardHeader>
          <CardTitle>Dados Recebidos</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className="text-xs overflow-auto max-h-96 bg-muted p-4 rounded">
            {JSON.stringify(dashboardData, null, 2)}
          </pre>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClientDashboardSimple;
